import { render, staticRenderFns } from "./ModalBuscarPacienteBackoffice.vue?vue&type=template&id=e67d9282&scoped=true"
import script from "./ModalBuscarPacienteBackoffice.vue?vue&type=script&lang=ts"
export * from "./ModalBuscarPacienteBackoffice.vue?vue&type=script&lang=ts"
import style0 from "./ModalBuscarPacienteBackoffice.vue?vue&type=style&index=0&id=e67d9282&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e67d9282",
  null
  
)

export default component.exports